"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ComponentContainer = _interopRequireDefault(require("../../../../../Framework/ComponentContainer"));
var _Actions = require("../../../../Reducers/UI/Actions");
var configuratorActions = _interopRequireWildcard(require("../../../../Reducers/Configurator/Actions"));
var _ConfigurationvariantSelection = _interopRequireDefault(require("../../Components/ConfigurationvariantSelection"));
var _ConfigurationvariantItem = _interopRequireDefault(require("../../Components/ConfigurationvariantItem"));
var _Carousel = _interopRequireDefault(require("../../../../../Framework/Components/Carousel"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mapStateToProps = function mapStateToProps(_ref) {
  var ui = _ref.ui,
    configurator = _ref.configurator,
    device = _ref.device;
  return {
    Component: _ConfigurationvariantSelection["default"],
    ItemComponent: _ConfigurationvariantItem["default"],
    Carousel: _Carousel["default"],
    show: !!ui.visibilityMap.configurationVariantSelection,
    configurationvariants: configurator.configurationvariants,
    selectedItem: configurator.configuration.item.identifier,
    screen: device.screen,
    // should re-render when the screen size changes

    showConfigurationVariantSelection: ui.visibilityMap.configurationvariantSelection
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _Actions.setVisible)('configurationVariantSelection', false));
    },
    onProceed: function onProceed(itemIdentifier, show) {
      dispatch((0, _Actions.setVisible)('optionlist', false));
      dispatch((0, _Actions.setVisible)('configurationVariantSelection', !show));
      dispatch(configuratorActions.fetchConfiguration(itemIdentifier));
    }
  };
};
var _default = exports["default"] = (0, _ComponentContainer["default"])(mapStateToProps, mapDispatchToProps);